// Wanted: 1025px - 1440px Found: 1024px
var BREAKPOINT_DESKTOP = 'xl';
// Wanted: 481px - 1024px Found: 481px
var BREAKPOINT_TABLET = 'md';
var MEDIA_DESKTOP = "@media $" + BREAKPOINT_DESKTOP + "}";
var MEDIA_TABLET = "@media $" + BREAKPOINT_TABLET;

export { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET, MEDIA_DESKTOP, MEDIA_TABLET };
